<template>
	<div id="app">
		<el-container>
			<el-header class="div-header">
				<Header />
				<el-divider class="header-divider"></el-divider>
			</el-header>

			<div class="main-div">
				<el-container class="main-div parentDiv">
					<splitpanes class="default-theme defaultStyle custom-splite">
						<pane size="100" class="SideBarLeft">
                        <!--SID1035 Body Part -->
							<template>
								<el-container>
									<div class="SID1035__AddSearchArticle">
                                        <!-- Breadcrumb section -->
                                        <el-breadcrumb separator-class="el-icon-arrow-right">
                                           <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                                            <!-- <el-breadcrumb-item :to="{ path: '0002' }">トップ画面(記事一覧)</el-breadcrumb-item> -->
                                            <!-- <el-breadcrumb-item :to="{ path: '0014' }">原文利用実績：照会条件設定</el-breadcrumb-item> -->
                                            <el-breadcrumb-item :to="{ path: '' }"> 原文利用実績照会設定</el-breadcrumb-item>
                                        </el-breadcrumb>
                                        
                                        <el-container>
                                            <el-tabs v-model= getactivename>
                                                <el-tab-pane  label="実績照会" name="first" class="div-inquiry-result">
                                                    <el-form ref="form" :model="form" label-width="auto">
                                                        <el-form-item class="radio-target"  label="集計対象">
															<el-radio v-model=form.radio_aggregation label="1" @change="showUserId">ユーザーID別</el-radio>
															<el-radio v-model=form.radio_aggregation label="2" @change="showUserId">ユーザーグループID別</el-radio>
														</el-form-item>
                                                        <el-form-item class="radio-aggregation" label="集計条件">
															<el-radio v-model=form.radio_target label="1"  @change="inputVisibleFunc">有</el-radio>
															<el-radio v-model=form.radio_target label="2"  @change="inputVisibleFunc">無</el-radio>
														</el-form-item>
                                                        
                                                        <el-form-item class="div-input-button" >
                                                            <el-form ref="form" :model="form" class="divMarginBottom">
                                                                <el-form-item label="" class="div-margin-right ">
                                                                    <!-- <el-input  ></el-input> -->
                                                                    <el-select
                                                                        :disabled="inputVisible" 
																		v-model="value"
																		multiple																		
                                                                        filterable
                                                                        remote
                                                                        reserve-keyword
                                                                        :remote-method="remoteMethod"
                                                                        :loading="loading"
																		placeholder=" "
                                                                        class="MultiSelectOption RemoteSelectOptin">
																		<el-option
																		v-for="item in options"
																		:key="item.value"
																		:label="item.name"
																		:value="item.value">
																		</el-option>
																	</el-select>
                                                                    <!-- <el-button type="primary" plain class="formButtonSearch">検索</el-button> -->
                                                                </el-form-item>                                                                
                                                            </el-form>
                                                        </el-form-item>
                                                        <el-form-item label="集計方法" class="radio_AggregationPeriod">
                                                            <!-- <el-radio-group v-model=radio> -->
                                                                <!-- <el-radio v-model=form.radio_AggregationPeriod :label="1">期間合計</el-radio>
                                                                <el-radio v-model=form.radio_AggregationPeriod :label="2">日別明細</el-radio>
                                                         -->
                                                            <el-radio  v-model=form.radio_AggregationPeriod label="1">期間合計</el-radio>
                                                            <el-radio  v-model=form.radio_AggregationPeriod label="2">日別明細</el-radio>
                                                        </el-form-item>
                                                        <el-form-item label="集計期間">
                                                            <v-date-picker
                                                            :masks="{ title: 'YYYY年MMM' }"
                                                            mode='range'
                                                            locale="ja"
                                                            v-model='range'
                                                            :popover="{  visibility: 'click' }"
                                                            :input-props = "{readonly: true}"
                                                            />
                                                        </el-form-item>
                                                        <el-form-item>
                                                            <el-button type="primary"  @click="clickUser('form')">照会</el-button>
                                                        </el-form-item>
                                                    </el-form>
                                                </el-tab-pane>
                                                <el-tab-pane label="頻度照会"  name="second" class="div-inquiry-result">
                                                    <el-form ref="getform1035" :model="getform1035"  :rules="rules">
                                                        <el-form-item class="radio-target radio-padding"  label="集計対象">
															<el-radio v-if="selectAllArticleFlag == 1" v-model=getform1035.radio_period label="0">全記事</el-radio>
															<el-radio v-if="ElArticleDisable == 1" v-model=getform1035.radio_period label="1">EL記事</el-radio>
                                                            <el-radio v-if="NikkeiArticleDisable == 1" v-model=getform1035.radio_period label="2">日経記事</el-radio>
														</el-form-item>
                                                        <el-form-item  label="集計期間">
                                                            <v-date-picker 
                                                            mode='range'
                                                             v-model="date" 
                                                             :masks="{ title: 'YYYY年MMM' }"
                                                              id="Date1035" 
                                                              locale="ja" 
                                                              :popover="{  visibility: 'click' }" 
                                                              :input-props = "{readonly: true}"
                                                              />
                                                        </el-form-item>
                                                        <el-form-item  label="利用件数" class="userNumberList" prop="InputNumberUser">
                                                            <el-input type='number' v-model="getform1035.InputNumberUser"></el-input>
                                                        </el-form-item>
                                                        <el-form-item  label="表示件数" prop="aggvalue"> 
                                                            <el-select v-model=getform1035.aggvalue placeholder="" >
															<el-option
															v-for="item in getaggoptions"
															:key="item.value"
															:label="item.label"
															:value="item.value">
															</el-option>
														</el-select>
                                                        </el-form-item>
                                                        <el-form-item label="">
                                                            <!-- <div > -->
                                                                <el-button type="primary" @click="radioClick('getform1035')" plain class="button-inquiry" >照会</el-button>
                                                            <!-- </div> -->
                                                        </el-form-item>
                                                    </el-form>
                                                    <!-- <el-row class="button-inquiry">
                                                        <el-button type="primary" plain>照会</el-button>
                                                    </el-row> -->
                                                </el-tab-pane>
                                            </el-tabs>
                                        </el-container>
                                        
                                    </div>
								</el-container>
							</template>
                        <!--SID1035 Body Part End-->
						</pane>
						<pane class="SideBarRight">
							<SideBar class="SidePane" />
						</pane>
					</splitpanes>
				</el-container>
			</div>
			<el-container class="footer-div">
				<el-footer class="footer-element">
					<FooterComponent />
				</el-footer>
			</el-container>
		</el-container>
	</div>
</template>
<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import router from '../../router';
import { mapGetters } from "vuex";
//import Vue from 'vue';

var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
//var FifteendaysBefore = CurrentDay - 14;
var EndDay = 0;
var StartDay = 0;  
var PreviousMonth;

var Month;
//if current date is 01, start date is first date of previous month and end date is last date of previous month
if(CurrentDay == 1)
{
	StartDay = 1;
	PreviousMonth = CurrentMonth - 1;
	EndDay = 0;
	Month = CurrentMonth;
	//CurrentMonth = CurrentMonth - 1;
}
else
{
	
	//else start date is first date of previous month and end date is first date of current month
	StartDay = 1;
	EndDay = CurrentDay - 1;
	PreviousMonth = CurrentMonth;
	Month = CurrentMonth;
}
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
export default {
	name: "app",
	components: {
		Header,
		SideBar,
		FooterComponent,
		Splitpanes,
		Pane
	},
	data() {
        var checkLength = (rule, value, callback) => {
		var passCheck= this.getform1035.InputNumberUser;
        
            if (passCheck < 5 || passCheck > 9999 ) {
              callback(new Error('Enter confirm password'));
            } 
            else {
              callback();
            }
		};
		return {
			form: {
                radio_aggregation: '1',
                radio_target: '2',
                radio_AggregationPeriod:'1'
            },
            radio: 3,
            getform1035:{
                radio_period:'0',
                aggvalue:'20',
                InputNumberUser: '5',
            },
            
            range: {
                start: new Date(CurrentYear, PreviousMonth, StartDay), // Jan 16th, 2018
				end: new Date(CurrentYear, Month, EndDay) // Jan 19th, 2018
                
            },
             date: {
                 start: new Date(CurrentYear, PreviousMonth, StartDay), // Jan 16th, 2018
                 end: new Date(CurrentYear, Month, EndDay) // Jan 19th, 2018
                
            },
            inputVisible: true,
            dummy: '',
            options: [],
            value: [],
            list: [],
            loading: false,
			ElArticleDisable: 0,
            NikkeiArticleDisable: 0,
            selectAllArticleFlag: 0,
            rules: {
            InputNumberUser: [
                { required: true, message: '利用件数を入力してください。'},
                {  validator:checkLength, message:'利用件数は5～9999以外の値を入力できません。'},
            ],
            aggvalue: [
                { required: true, message: '利用件数を入力してください。'},
            ],
            },
                
        };
	},
    computed: {
		...mapGetters("situation1035", [
            "getactivename",
            "getaggoptions",
            "getUserIDSearchResult",
            "getUserGroupIDSearchResult"
        ]),
        ...mapGetters("situation0001", [
            "getNews_Article_Flag",
            "getUserGroup_News_Article_Flag",
            "getWeb_News_Article_Flag",
            "getUserGroup_Web_News_Article_Flag",
            "getMC_Article_Flag",
            "getSC_Article_Flag"
        ])
	},
   
     methods: {
        inputVisibleFunc(){
this.$LogButtonEvent("1035","AggregationCondition");
this.$LogMethodIN("1035","inputVisibleFunc");
                var visible = this.form.radio_target;
                
                if(visible == 2){
                    this.inputVisible = true;
                    //document.getElementById("Button").disabled = true;

                }else{
                    this.inputVisible = false;
                }
                this.$LogMethodOut("1035","inputVisibleFunc");
         },
        showUserId(){
this.$LogButtonEvent("1035","TargetOfAggregation");
this.$LogMethodIN("1035","showUserId");
            var userRadiobtn =this.form.radio_aggregation;
            var Resp=[];
            if(userRadiobtn == 1){
               
                this.getUserGroupIDSearchResult="";
                
              
                
                this.$store.dispatch("communication1035/getUserIdData").then(()=>{
                    
                    this.options=[];
                
                for(var i=0; i<this.getUserIDSearchResult.length;i++){
                    var respArray=this.getUserIDSearchResult[i].name;
                    Resp.push(respArray);
                    this.list = Resp.map(item => {
                    return { value: `${item}`, name: `${item}` };
                });
               
                this.value=null;
                this.name=null;
                this.options=null;
                //this.getUserGroupIDSearchResult=null;
            }
            });
                
            }
            else{
                
                this.getUserIDSearchResult="";

               var Resp_1=[];
                this.$store.dispatch("communication1035/getUserGroupIdData").then(()=>{
                    
                    this.options=[];
               
                for(var j=0; j<this.getUserGroupIDSearchResult.length;j++){
                    var respArrayGroup=this.getUserGroupIDSearchResult[j].name;
                    Resp_1.push(respArrayGroup);
                    this.list = Resp_1.map(item => {
                    return { value: `${item}`, name: `${item}` };
                });
                
                }
                this.value=null;
                this.name=null;
                this.options=null;
                //this.getUserGroupIDSearchResult=null;

                });
               
            }
            this.$LogMethodOut("1035","showUserId");
        },
      onSubmit() {},
        tableClick() {
         this.dummy ="送信されました";
        },
        clickUser(formName){
this.$LogButtonEvent("1035","Inquiry");
this.$LogMethodIN("1035","clickUser");
           
            var startDate;
			var sdate;
			var startResult;
			var endDate;
			var edate;
			var endResult;
			var aggregationPeriod;
			var smnth;
			var sday;
			var emnth;
            var eday;
            startDate = this.range.start;
            sdate = new Date(startDate),
            smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
            sday = ("0" + sdate.getDate()).slice(-2);
            startResult = [sdate.getFullYear(), smnth, sday].join("/");
            endDate = this.range.end;
            edate = new Date(endDate),
            emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
            eday = ("0" + edate.getDate()).slice(-2);
            // 2021/01/27 #10483 START
            //endResult = [sdate.getFullYear(), emnth, eday].join("/");
            endResult = [edate.getFullYear(), emnth, eday].join("/");
            // 2021/01/27 #10483 END
            aggregationPeriod = startResult + ' ~ ' + endResult;
           
            var userRadio =this.form.radio_aggregation;
            var userGroupList ='';
            var userIdList='';
            var aggregationValAuthority='';
            var aggregationValAuthority_Group ='';            
            if(userRadio == 1){
            //For the name of user Find the respective userid
            
            if(this.value == null){
                
                userIdList ={
                        start_day:startResult,
                        end_day:endResult,
                        user_id_info:tableContent,
                    };

                    aggregationValAuthority={
                    user_name:''
                };
                
            }else{
				
                var pushAgg_id=[];
                var FinalAggVal=[];
				var index_Agg='';
				for(var s=0;s<this.getUserIDSearchResult.length;s++){
					pushAgg_id.push(this.getUserIDSearchResult[s].name);
				}
                for(var m=0; m<this.value.length;m++){
                    index_Agg=pushAgg_id.indexOf(this.value[m]);
                FinalAggVal.push(this.getUserIDSearchResult[index_Agg].value);
                }
                var tableContent=[];
                for(var n=0; n<FinalAggVal.length;n++){
                    var tableContent1={};
                        tableContent1.user_id=FinalAggVal[n];
                        tableContent.push(tableContent1);
                        //var finalUserID=FinalAggVal[n];
                }
                 // For userId details in formatted here
                     userIdList ={
                        start_day:startResult,
                        end_day:endResult,
                        user_id_info:tableContent,
                    };
                     aggregationValAuthority={
                    user_name:this.value
                };
            }      
                
            }else{
                if(this.value == null){

                    userGroupList ={
                        user_group_name_info:tableContentgroup,
                        start_day:startResult,
                        end_day:endResult
                    
                    };
                    aggregationValAuthority_Group={
                    userGroup_name:''
                };
                }else{
                
                //For the UserGroupName of user Find the respective user_group_id
                    
                    
                    var pushAggGroup_id=[];
                    var FinalAggGroupVal=[];
                    var index_AggGroup='';
                    for(var s1=0;s1<this.getUserGroupIDSearchResult.length;s1++){
                        pushAggGroup_id.push(this.getUserGroupIDSearchResult[s1].name);
                    }
                    for(var m1=0; m1<this.value.length;m1++){
                        index_AggGroup=pushAggGroup_id.indexOf(this.value[m1]);
                    FinalAggGroupVal.push(this.getUserGroupIDSearchResult[index_AggGroup].value);
                    }
                    var tableContentgroup=[];
                    for(var j=0;j<FinalAggGroupVal.length;j++){
                        
                        var tableContentGroup1={};
                        tableContentGroup1.user_group_name=this.value[j];

                        tableContentgroup.push(tableContentGroup1);
                        
                    }
                     // For userGroup details in formatted here
                     userGroupList ={
                        user_group_name_info:tableContentgroup,
                        start_day:startResult,
                        end_day:endResult
                    
                    };
                    aggregationValAuthority_Group={
                    userGroup_name:this.value
                };
            }    
        }
                   
            
            this.$refs[formName].validate((valid) => {
			if (valid) {
                if(this.form.radio_aggregation == 1 && this.form.radio_AggregationPeriod == 1){
                   
                    router.push({ name: "1038",params: { userIdList: aggregationValAuthority,csvParams: userIdList} });  
                    this.$store.dispatch('communication1038/getInquiryConditionData_1038',userIdList);
                    this.$store.commit('situation1038/setAggregationcondition', aggregationPeriod);
                }
                else if(this.form.radio_aggregation == 1 && this.form.radio_AggregationPeriod == 2){
                    router.push({ name: "1039" ,params: { userIdList: aggregationValAuthority,csvParams: userIdList }});
                    this.$store.dispatch('communication1039/getInquiryConditionData_1039',userIdList);
                    this.$store.commit('situation1039/setAggregationcondition', aggregationPeriod);
                }
                else if(this.form.radio_aggregation == 2 && this.form.radio_AggregationPeriod == 1){
                    router.push({ name: "1036", params: { userGroupList: aggregationValAuthority_Group,csvParams: userGroupList }});
                    this.$store.dispatch('communication1036/getInquiryConditionData_1036',userGroupList);
                    this.$store.commit('situation1036/setAggregationcondition', aggregationPeriod);
                }
                else{
                    router.push({ name: "1037", params: { userGroupList: aggregationValAuthority_Group,csvParams: userGroupList } });
                    this.$store.dispatch('communication1037/getInquiryConditionData_1037',userGroupList);
                    this.$store.commit('situation1037/setAggregationcondition', aggregationPeriod);
                }
        } else {
				return false;
			}

        });
    this.$LogMethodOut("1035","clickUser");
    },
        radioClick(formName) {
this.$LogButtonEvent("1035","InquiryClickTab2");
this.$LogMethodIN("1035","radioClick");
            this.$refs[formName].validate((valid) => {
			if (valid) {
                var startDate;
                var sdate;
                var periodStartResult;
                var endDate;
                var edate;
                var periodEndResult;
                var smnth;
                var sday;
                var emnth;
                var eday;
                var aggregationPeriod_secondtab;
                startDate = this.date.start;
                sdate = new Date(startDate),
                smnth = ("0" + (sdate.getMonth() + 1)).slice(-2),
                sday = ("0" + sdate.getDate()).slice(-2);
                periodStartResult = [sdate.getFullYear(), smnth, sday].join("/");
                endDate = this.date.end;
                edate = new Date(endDate),
                emnth = ("0" + (edate.getMonth() + 1)).slice(-2),
                eday = ("0" + edate.getDate()).slice(-2);
                // 2021/01/27 #10483 START
                //periodEndResult = [sdate.getFullYear(), emnth, eday].join("/");
                periodEndResult = [edate.getFullYear(), emnth, eday].join("/");
                // 2021/01/27 #10483 END
                aggregationPeriod_secondtab = periodStartResult + ' ~ ' + periodEndResult;
               
                
                var  SearchInquiry={
                    data_section: this.getform1035.radio_period,
                    start_date:periodStartResult,
                    end_date:periodEndResult,
                    read_count:this.getform1035.InputNumberUser,
                    items_count:this.getform1035.aggvalue
                    
                    };
                    
                   this.$store.dispatch('communication1045/getInquiryConditionData_1045',SearchInquiry);
                   this.$store.commit('situation1045/setAggregationcondition', aggregationPeriod_secondtab);
                   this.$store.commit('situation1045/setInquiryPeriodUserDisplayCount', this.getform1035.aggvalue);
                   router.push({ name: "1045",params: { SearchInquiry: SearchInquiry } });

			} else {
				return false;
			}
			});
            this.$LogMethodOut("1035","radioClick"); 
        },
        remoteMethod(query) {
this.$LogButtonEvent("1035","Selectdropdownvalue");
this.$LogMethodIN("1035","remoteMethod"); 
            if (query !== '') {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.options = this.list.filter(item => {
                return item.name.toLowerCase()
                    .indexOf(query.toLowerCase()) > -1;
                });
            }, 200);
            } else {
            this.options = [];
            }
            this.$LogMethodOut("1035","remoteMethod"); 
        }
    },
    
    mounted() {

        /*** Change by AJ for backlog Id: 1497 */
        /*Code for active the tab while loading from SID1045 */
        if(this.$route.params.fromSID1045 == 1)
        {
            this.$store.commit('situation1035/setActiveName', "second");
        }
        else
        {
            this.$store.commit('situation1035/setActiveName', "first");
        }
        /*Code for active the tab while loading from SID1045 */
        /*** Change by AJ for backlog Id: 1497 */
    //Get table articles during page load
        this.$store.dispatch("communication1035/getUserIdData").then(()=>{
    var Resp=[];
    
    for(var k=0; k<this.getUserIDSearchResult.length;k++){
                    var respArray=this.getUserIDSearchResult[k].name;
                    Resp.push(respArray);
                    this.list = Resp.map(item => {
                    return { value: `${item}`, name: `${item}` };
                });
            }
        });
        this.value=null;
        this.name=null;
        this.options=null;

    /*** Worked by AJ for backlog Id: 1552 */

    //get the MC_article_flag from the session
    this.news_article_flag = this.getMC_Article_Flag

    //get the SC_article_flag from the session
    this.web_news_article_flag = this.getSC_Article_Flag

    // For show/hide the EL article radio button
    if(this.news_article_flag == true)
    {
        this.ElArticleDisable = 1;
        //Code for selected EL radio button
        this.getform1035.radio_period = '1';
    }

    // For show/hide the Nikkie article radio button
    if(this.web_news_article_flag == true)
    {
        this.NikkeiArticleDisable = 1;
        //Code for selected Nikkie radio button
        this.getform1035.radio_period = '2';
    }

    // For show/hide the All article radio button
    if(this.ElArticleDisable == 1 && this.NikkeiArticleDisable == 1)
    {
        this.selectAllArticleFlag = 1;
        //Code for selected All Articles radio button
        this.getform1035.radio_period = '0';
    }

    


    },

    beforeCreate(){
        //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
    },
    created(){
          //For the screen Title
     document.title = "原文利用実績照会条件設定画面";
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "1035.css";
</style>